/*
 * Quote（法人・大量注文 お見積り依頼）固有スクリプト
 * 商品行（商品名・数量・備考）の動的追加/削除のみを扱う。会社名等の基本項目・送信後の
 * 成否表示はShopify標準のcontactフォームにそのまま任せるため、こちらでは状態管理しない
 * （旧実装は独自のフェイク送信状態を持っていたが、テンプレート側が実データ送信する作りに
 * なった後も追従しておらず、存在しない要素を参照してrender()が例外で止まっていた。
 * 商品行が最初から表示されない・追加ボタンが反応しないのはこれが原因。2026-10-21書き直し）。
 * 送信直前に、商品行の内容を1つのテキストに整形してcontact[body]（隠しtextarea）に
 * 詰めてからネイティブ送信する。
 */
(function (SANBY) {
  const { escapeHtml } = SANBY.utils;

  let nextId = 2;
  let rows = [{ id: 1, name: "", qty: 50, note: "" }];

  function renderRows() {
    const container = document.querySelector("[data-quote-rows]");
    if (!container) return;
    container.innerHTML = rows
      .map(
        (r) => `
      <div class="quote-row" data-row-id="${r.id}">
        <input type="text" class="form-input quote-row-name" data-row-field="name" value="${escapeHtml(r.name)}">
        <input type="number" min="1" class="form-input quote-row-qty" data-row-field="qty" value="${r.qty}">
        <input type="text" class="form-input quote-row-note" data-row-field="note" value="${escapeHtml(r.note)}">
        <button type="button" class="quote-row-remove" data-row-remove aria-label="この行を削除"${rows.length <= 1 ? " disabled" : ""}>×</button>
      </div>`
      )
      .join("");
  }

  function serializeRows() {
    return rows
      .filter((r) => r.name.trim())
      .map((r) => `・${r.name}　数量: ${r.qty}${r.note.trim() ? `　備考: ${r.note}` : ""}`)
      .join("\n");
  }

  function init() {
    const rowsContainer = document.querySelector("[data-quote-rows]");
    const addBtn = document.querySelector("[data-add-row]");
    const form = document.querySelector("[data-quote-form]");
    const bodyField = document.querySelector("[data-quote-body-hidden]");
    if (!rowsContainer || !addBtn || !form) return;

    renderRows();

    addBtn.addEventListener("click", () => {
      rows.push({ id: nextId++, name: "", qty: 50, note: "" });
      renderRows();
    });

    rowsContainer.addEventListener("input", (e) => {
      const rowEl = e.target.closest("[data-row-id]");
      if (!rowEl) return;
      const id = Number(rowEl.dataset.rowId);
      const field = e.target.dataset.rowField;
      const row = rows.find((r) => r.id === id);
      if (!row) return;
      if (field === "qty") row.qty = Number(e.target.value) || 1;
      else row[field] = e.target.value;
    });

    rowsContainer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-row-remove]");
      if (!btn || rows.length <= 1) return;
      const id = Number(btn.closest("[data-row-id]").dataset.rowId);
      rows = rows.filter((r) => r.id !== id);
      renderRows();
    });

    form.addEventListener("submit", () => {
      if (bodyField) bodyField.value = serializeRows();
      const submitBtn = document.querySelector("[data-quote-submit]");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add("is-loading");
        submitBtn.innerHTML = `<span class="plp-cart-spinner" aria-hidden="true"></span> 送信中...`;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})(window.SANBY);
